import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import {
  IS_API_GATEWAY,
  IS_PRIVATE_API,
} from '@personal-area/global/http/models';
import { Tariff } from '@personal-area/global/accounts/models';

type GetTariffsResponse = { items: Tariff[] };

export const tariffURLs = {
  getTariffs: '/v3/tariff/list',
};

@Injectable({ providedIn: 'root' })
export class TariffService {
  constructor(private _http: HttpClient) {}

  public fetchTariffs(hasReferral = false): Observable<Tariff[]> {
    return this._http
      .get<GetTariffsResponse>(tariffURLs.getTariffs, {
        params: { hasReferral },
        context: new HttpContext()
          .set(IS_API_GATEWAY, true)
          .set(IS_PRIVATE_API, true),
      })
      .pipe(map((response) => response.items));
  }
}
